import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  container: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      alignItems: "center",
    },
  },
  root: {
    display: "flex",
    "& > *": { margin: theme.spacing(0) },
  },
  icon: {
    width: 24,
    height: 24,
    "& span": {
      color: ({ finishedLesson }) =>
        finishedLesson
          ? theme.palette.success.main
          : theme.palette.text.primary,
    },
    backgroundColor: "transparent",
  },
  lessonTitle: {
    cursor: ({ hasLinkVideo }) => (hasLinkVideo ? "pointer" : "default"),
    textDecoration: ({ hasLinkVideo }) => (hasLinkVideo ? "underline" : "none"),
    color: ({ hasLinkVideo }) =>
      hasLinkVideo ? theme.palette.link.main : theme.palette.text.primary,
    fontSize: "0.9rem",
  },
  info: {
    flex: 1,
  },
  infoRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    flexWrap: "wrap",
  },
  buttons: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
    width: "fit-content",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      justifyContent: "flex-end",
      marginTop: 0,
    },
  },
  formList: {
    listStyle: "none",
    paddingLeft: 0,
    marginTop: theme.spacing(2),
  },
  formItem: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  formTitle: {
    fontWeight: "bold",
    fontSize: "1.1rem",
    color: theme.palette.primary.main,
  },
  iconSmall: {
    fontSize: 18,
  },
  iconSuccess: {
    color: theme.palette.success.main,
  },
  iconGray: {
    color: theme.palette.text.disabled,
  },
  buttonBase: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(0.5),
    "& .MuiButton-label": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: theme.spacing(0.5),
    },
    "& .MuiIcon-root": {
      marginBottom: theme.spacing(0.5),
    },
  },
  watchButton: {
    color: ({ watchedSomething }) =>
      watchedSomething ? theme.palette.success.main : theme.palette.error.main,
  },
  unavailableButton: {
    "& .MuiButton-label": {
      color: theme.palette.text.disabled,
    },
    "& .MuiIcon-root": {
      color: theme.palette.text.disabled,
    },
  },
  speakerInfo: {
    marginLeft: theme.spacing(1.5),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    flexWrap: "wrap",
    "& > div": {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(0.5),
      "& .MuiIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
      },
      "& .MuiTypography-root": {
        color: theme.palette.text.secondary,
      },
    },
  },
  iconStep: {
    color: "#fff",
  },
  listOndemandConditionButtonContainer: {
    alignItems: "center",
    gap: theme.spacing(2.5),
    display: "flex",
    "& .quiz-buttons-container": {
      gap: theme.spacing(1),
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "& .btn-watch": {
      "& .MuiButton-label": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      },
    },
    "& .btn-watch[data-disabled='true']": {
      opacity: 0.2,
    },
  },
  buttonLabel: {
    minWidth: 50,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(0.5),
  },
  buttonIcon: {
    fontSize: "x-large !important",
    marginBottom: theme.spacing(0.5),
  },
  complementaryButton: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(0.5),
    "& .MuiButton-label": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: theme.spacing(0.5),
      color: "#32b126",
    },
    "& .MuiIcon-root": {
      color: "#32b126",
      marginBottom: theme.spacing(0.5),
    },
  },
  listOnDemandContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  timeContainer: {
    "& .MuiTypography-root": {
      textAlign: "center",
      fontSize: "0.9rem",
    },
  },
  day: {
    "&.MuiTypography-root": {
      fontSize: "1.4rem",
      lineHeight: 1,
    },
  },
  month: {
    "&.MuiTypography-root": {
      fontSize: "1.1rem",
      lineHeight: 1,
    },
  },
  listOndemand: {
    padding: theme.spacing(1),
    "&[data-has-time=true]": {
      borderLeft: `5px solid ${theme.palette.primary.main}`,
    },
    width: "100%",
    "& ul": {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      listStyle: "none",
      margin: 0,
      padding: 0,
      marginBottom: theme.spacing(2),
      "& li": {
        display: "flex",
        alignContent: "space-between",
        alignItems: "flex-start",
        gap: theme.spacing(1.25),
        paddingRight: theme.spacing(2),
        "& em": {
          display: "flex",
          flex: 1,
          fontStyle: "normal",
          fontSize: "1rem",
          fontWeight: "bold",
        },
        "& button": {
          "& .MuiButton-label": {
            "& p": {
              lineHeight: "0.8 !important",
              padding: "0 !important",
            },
          },
        },
      },
    },
  },
  resultItem: {
    marginBottom: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[1],
    padding: theme.spacing(2),
  },
  courseInfoContainer: {
    marginBottom: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.25),
  },
  courseInfoHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    flexDirection: "column",
    gap: theme.spacing(0.25),
  },
  courseInfoText: {
    flex: 1,
  },
  courseTitle: {
    color: theme.palette.text.primary,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.25),
    fontWeight: 500,
    fontSize: "1rem",
  },
  courseInfoDetails: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(0.25),
    alignItems: "center",
    fontSize: "0.875rem",
  },
  infoItem: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    color: theme.palette.text.secondary,
    fontSize: "0.875rem",
  },
  infoIcon: {
    color: theme.palette.text.secondary,
    fontSize: "1rem",
  },
  divider: {
    margin: theme.spacing(1, 0),
    borderColor: theme.palette.divider,
  },
  formAccordion: {
    marginBottom: theme.spacing(2),
    boxShadow: "none",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    "&:before": {
      display: "none",
    },
    "& .MuiAccordionSummary-root": {
      padding: theme.spacing(1),
      minHeight: "auto",
      "& .MuiAccordionSummary-content": {
        margin: 0,
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
      },
      "& .MuiAccordionSummary-expandIcon": {
        marginRight: theme.spacing(1),
        marginLeft: 0,
        padding: theme.spacing(0.5),
        color: theme.palette.text.secondary,
      },
    },
  },
  questionAccordion: {
    marginBottom: theme.spacing(1),
    boxShadow: "none",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    "&:before": {
      display: "none",
    },
    "& .MuiAccordionSummary-root": {
      padding: theme.spacing(1),
      minHeight: "auto",
      "& .MuiAccordionSummary-content": {
        margin: 0,
      },
      "& .MuiAccordionSummary-expandIcon": {
        marginRight: theme.spacing(1),
        marginLeft: 0,
        padding: theme.spacing(0.5),
        color: theme.palette.text.secondary,
      },
    },
  },
  questionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    gap: theme.spacing(1),
  },
  questionTitle: {
    fontWeight: 500,
    fontSize: "0.875rem",
    color: theme.palette.text.primary,
    flex: 1,
  },
  questionStatus: {
    marginLeft: theme.spacing(1),
    "&[data-correct=false]": {
      backgroundColor: theme.palette.text.disabled,
      color: theme.palette.text.secondary,
      "& .MuiChip-icon": {
        color: theme.palette.text.secondary,
      },
    },
    "&[data-correct=true]": {
      backgroundColor: theme.palette.success.light,
      color: theme.palette.success.main,
      "& .MuiChip-icon": {
        color: theme.palette.success.main,
      },
    },
  },
  answersContainer: {
    width: "100%",
    padding: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
  },
  answerItem: {
    padding: theme.spacing(0.5),
    fontSize: "0.875rem",
    "& .answer-letter": {
      minWidth: "20px",
      fontWeight: 500,
      color: theme.palette.text.secondary,
    },
    "& .answer-content": {
      flex: 1,
    },
  },
  answerText: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.25),
    color: theme.palette.text.primary,
    fontSize: "0.875rem",
  },
  correctAnswer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.25),
    backgroundColor: theme.palette.success.light,
    border: `1px solid ${theme.palette.success.main}`,
    color: theme.palette.success.main,
    fontWeight: 500,
    "& .answer-letter": {
      color: theme.palette.success.main,
    },
  },
  incorrectAnswer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.25),
    color: theme.palette.text.secondary,
    "& .answer-letter": {
      color: theme.palette.text.secondary,
    },
    "& .answer-content": {
      textDecoration: "line-through",
    },
  },
  resultSummary: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
    marginTop: theme.spacing(1),
    padding: theme.spacing(1),
    fontSize: "0.875rem",
    backgroundColor:
      theme.palette?.quizResults?.summary?.background ||
      (theme.palette.mode === "dark"
        ? "rgba(255, 255, 255, 0.05)"
        : "rgba(0, 0, 0, 0.02)"),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${
      theme.palette?.quizResults?.summary?.border ||
      (theme.palette.mode === "dark"
        ? "rgba(255, 255, 255, 0.12)"
        : "rgba(0, 0, 0, 0.12)")
    }`,
  },
  yourAnswerText: {
    color: theme.palette.text.secondary,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    "& .answer-letter": {
      fontWeight: 500,
      color: theme.palette.text.primary,
      lineHeight: "1.43",
    },
  },
  correctAnswerText: {
    color: theme.palette.success.main,
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    "& .answer-letter": {
      fontWeight: 500,
      color: theme.palette.success.main,
      lineHeight: "1.43",
    },
  },
  questionsContainer: {
    width: "100%",
  },
  "grid-header": {
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  "text-header": {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },
  "icon-header": {
    float: "right",
    color: theme.palette.text.secondary,
    "&:hover": {
      color: theme.palette.error.main,
    },
  },
  modalContent: {
    padding: theme.spacing(2),
    height: "auto",
    overflow: "auto",
    backgroundColor: theme.palette.background.default,
    position: "relative",
    "& .grid-complet": {
      height: "100%",
    },
  },
  modalHeader: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  modalTitle: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: theme.palette.text.primary,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(2),
    top: theme.spacing(2),
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  courseInfo: {
    marginBottom: theme.spacing(3),
  },
  formHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    "& .score-container": {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1),
      padding: theme.spacing(0.5, 1),
      backgroundColor: theme.palette?.quizResults?.score?.background,
      borderRadius: theme.shape.borderRadius,
      border: `1px solid ${theme.palette?.quizResults?.score?.border}`,
      "& .score-value": {
        fontWeight: 600,
        color: theme.palette?.quizResults?.score?.value,
      },
      "& .score-label": {
        color: theme.palette?.quizResults?.score?.label,
        fontSize: "0.75rem",
      },
    },
  },
  formTitle: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  formContent: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    width: "100%",
  },
  alert: {
    marginBottom: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    maxWidth: 800,
    width: "90%",
    maxHeight: "90vh",
    overflow: "auto",
  },
  title: {
    marginBottom: theme.spacing(3),
    color: theme.palette.text.primary,
  },
  summary: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.quizResults.summary.background,
    border: `1px solid ${theme.palette.quizResults.summary.border}`,
  },
  score: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.quizResults.score.background,
    border: `1px solid ${theme.palette.quizResults.score.border}`,
    marginBottom: theme.spacing(2),
  },
  scoreValue: {
    fontSize: "2rem",
    fontWeight: "bold",
    color: theme.palette.quizResults.score.value,
    marginRight: theme.spacing(1),
  },
  scoreLabel: {
    color: theme.palette.quizResults.score.label,
  },
  formAccordionSummary: {
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius,
    "&.Mui-expanded": {
      margin: 0,
    },
  },
  formAccordionDetails: {
    padding: theme.spacing(2),
    flexDirection: "column",
  },
  questionAccordion: {
    marginBottom: theme.spacing(2),
    "&:before": {
      display: "none",
    },
  },
  questionAccordionSummary: {
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius,
    "&.Mui-expanded": {
      margin: 0,
    },
  },
  questionAccordionDetails: {
    padding: theme.spacing(2),
    flexDirection: "column",
  },
  questionNumber: {
    fontWeight: "bold",
    marginRight: theme.spacing(1),
  },
  questionStatusCorrect: {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.success.main,
    border: `1px solid ${theme.palette.success.main}`,
  },
  questionStatusIncorrect: {
    backgroundColor: theme.palette.text.disabled,
    color: theme.palette.text.secondary,
    border: `1px solid ${theme.palette.text.secondary}`,
  },
  answer: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
  },
  userAnswer: {
    backgroundColor: theme.palette.quizResults.chip.background,
    border: `1px solid ${theme.palette.quizResults.chip.border}`,
  },
  finalQuizInlineCard: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  videoQuizInlineCard: {
    display: "flex",
    flexDirection: "column",
  },
  quizItemWithResultsButton: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  retakeButton: {
    marginLeft: theme.spacing(1),
    '& .MuiButton-label': {
      color: theme.palette.primary.main,
    },
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));
